import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from '../../store';
import { User } from '../../store/types';
import './Navbar.css';

interface NavbarItemProps {
    icon: React.ReactNode;
    link: string;
    label: string | JSX.Element;
    isActive: boolean;
    currentUser: User | null;
    userRole?: string;
    user?: User;
    spacer?: boolean;
    externalLink?: boolean;
    onClick?: () => void;
    dataTestId?: string;
}

class NavbarItem extends Component<NavbarItemProps> {
    render() {
        if (
            !this.props.userRole ||
            this.props.userRole !== this.props.currentUser?.userRole.key
        ) {
            return null;
        }

        if (this.props.link !== '' && !this.props.externalLink) {
            return (
                <li
                    className={`nav-item ${this.props.spacer ? 'spacer' : ''} ${
                        this.props.isActive ? 'active' : ''
                    }`}
                >
                    {!this.props.spacer && (
                        <Link
                            className={`nav-link ${
                                this.props.isActive ? 'active' : ''
                            }`}
                            to={this.props.link}
                            onClick={this.props.onClick}
                            data-testid={this.props.dataTestId}
                        >
                            <div className='susy-nav-item'>
                                <div className='susy-nav-icon'>
                                    {this.props.icon}
                                </div>
                                <div className='susy-nav-label'>
                                    {this.props.label}
                                </div>
                            </div>
                        </Link>
                    )}
                </li>
            );
        }

        return (
            <li className={`nav-item ${this.props.spacer ? 'spacer' : ''}`}>
                {!this.props.spacer && (
                    <Link
                        className={`nav-link ${
                            this.props.isActive ? 'active' : ''
                        }`}
                        to={this.props.link}
                        onClick={this.props.onClick}
                        data-testid={this.props.dataTestId}
                    >
                        <div className='susy-nav-item'>
                            <div className='susy-nav-icon'>
                                {this.props.icon}
                            </div>
                            <div className='susy-nav-label'>
                                {this.props.label}
                            </div>
                        </div>
                    </Link>
                )}
            </li>
        );
    }
}

const mapStateToProps = (state: RootState) => {
    return {
        currentUser: state.auth.currentUser,
    };
};

export default connect(mapStateToProps)(NavbarItem);
